export default __webpack_public_path__ + "1786e7cbfb9e3cd70a06f807983bcabb.png";